import { action } from './';

export const SHOW_IMAGE_MODAL = 'SHOW_IMAGE_MODAL';
export const HIDE_IMAGE_MODAL = 'HIDE_IMAGE_MODAL';

export const showImageModal = image => action(SHOW_IMAGE_MODAL, { image });
export const hideImageModal = () => action(HIDE_IMAGE_MODAL);



// WEBPACK FOOTER //
// ./src/actions/image.js